module.exports = __webpack_public_path__ + "img/blis7.44b83590.png";